import RegistrationOfInterestForm from './RegistrationOfInterestForm.component';

export default RegistrationOfInterestForm;